import { TFunction } from 'i18next';
import { filterUndefinedRows } from 'src/js/pages/statistic/statistic-mapper';
import { StatisticSectionViewModel } from 'src/js/pages/statistic/statistic-view-model';
import { toTitleCase } from 'src/js/util/global-util';
import { formatUptime } from '../stream/stream-helper';

import { AudioEncoderViewModel, encoderStateToName } from './audio-encoder-models';

export const mapAudEncToStatistics = (audEnc: AudioEncoderViewModel, t: TFunction): StatisticSectionViewModel[] => {
  const stats = [
    {
      title: t('statistics.header.statistics'),
      rows: [
        {
          name: t('general.status'),
          value: toTitleCase(encoderStateToName(audEnc.state, t), false),
        },
        {
          name: t('audioEncoder.statistics.encodedFrames'),
          value: audEnc.stats.encodedFrames,
        },
        {
          name: t('audioEncoder.statistics.encodedFramerate'),
          value: audEnc.stats.encodedFramerate,
        },
        {
          name: t('audioEncoder.statistics.encodedBytes'),
          value: audEnc.stats.encodedBytes,
        },
        {
          name: t('audioEncoder.statistics.encodedBitrate'),
          value: `${audEnc.stats.encodedBitrate} kbps`,
        },
        {
          name: t('audioEncoder.statistics.encoderErrors'),
          value: audEnc.stats.encoderErrors,
        },
        {
          name: t('audioEncoder.statistics.encoderPTS'),
          value: audEnc.stats.encoderPTS,
        },
        {
          name: t('audioEncoder.statistics.maxSampleValue'),
          value: `${audEnc.stats.maxSampleValue} (${audEnc.stats.maxSampleValuePercentage}%)`,
          when: audEnc.stats.maxSampleValue != null,
        },
        {
          name: t('audioEncoder.statistics.maximumVuLevel'),
          value: audEnc.stats.maximumVuLevel,
        },
        {
          name: t('audioEncoder.statistics.passthroughType'),
          value: audEnc.stats.passthroughType,
        },
        {
          name: t('audioEncoder.statistics.passthroughDetectedAlgorithm'),
          value: audEnc.stats.passthroughDetectedAlgorithm,
        },
        {
          name: t('audioEncoder.statistics.passthroughDetectedSamplerate'),
          value: audEnc.stats.passthroughDetectedSamplerate,
        },
        {
          name: t('audioEncoder.statistics.passthroughDetectedBitDepth'),
          value: audEnc.stats.passthroughDetectedBitDepth,
        },
        {
          name: t('audioEncoder.statistics.passthroughErrors'),
          value: audEnc.stats.passthroughErrors,
        },
        {
          name: t('statistics.stream.rows.lastReset'),
          value: formatUptime(audEnc.stats.lastReset),
        },
      ],
    },
  ];

  return filterUndefinedRows(stats);
};
